// extracted by mini-css-extract-plugin
export default {"content":"HomePage_content__FZgfX","name":"HomePage_name__TG10l","role":"HomePage_role__Bkly4"};